import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// Inventory: S-ADMIN and the marketing team, and the purchasing team to look (they need stock and cost prices).
export const inventoryGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',').map((r: string) => r.trim());
  if (userInfo.isLoggedIn && (roles.includes('S-ADMIN') || roles.includes('MARKETING') || roles.includes('PURCHASE'))) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};
